function accept(value) {
  return [true, value];
}

function decline(value) {
  return [false, value];
}

export function validateEmail(value) {
  if (value.length === 0) {
    return decline('Введите E-Mail');
    // eslint-disable-next-line no-useless-escape
  } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
    return decline('Неверный формат E-Mail');
  }

  return accept();
}

export function validateFio(value) {
  if (!value) {
    return decline('Введите ФИО');
  }

  const fioShort = value.split(' ').filter((word) => word.length > 0);
  if (fioShort.length < 3) {
    return decline('ФИО должно состоять из трёх слов');
  }

  return accept(
    `${fioShort[0]} ${fioShort[1].substring(0, 1).toUpperCase()}. ${fioShort[2].substring(0, 1).toUpperCase()}.`
  );
}
